/* @flow */

export default class UpdateMandateRequest {
  isoCompanyId: number;
  mandateId: number;
  amount: number;
}
